import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        $scope,
        Alert) {
		this.$state = $state;
		this.$scope = $scope;
		this.Alert = Alert;
		this.st= new SmartTable();
	}
	
	  $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.Alert('success', 'global.data_copied')
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.controller.js